import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from '../components/general/modal/modal';
import TextInput from '../components/form/text/text';
import Button from '../lj_shared/button/button';
import { postJSON, handleRequestError } from '../lib/request_deprecated';
import RequestInfoModalUtils from './request_info_modal_utils';

const styles = require('./request_info_modal.module.scss');

interface Props {
  applicationId: any;
  name: string;
  requestMadeTrigger: any;
  urls: any;
  requestInfo?: any;
}

interface State {
  request_information: string;
  requestModal?: any;
}
type StateKeys = keyof State;
class RequestInfoModal extends React.Component<Props, State> {
  modalRef: any;
  messageRef: any;

  constructor(props: Props) {
    super(props);
    this.modalRef = React.createRef();
    this.messageRef = React.createRef();
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleInfoRequest = this.handleInfoRequest.bind(this);
    const requestModal = new RequestInfoModalUtils({
      requestInfo: props.requestInfo,
      name: props.name,
    }).props();
    this.state = {
      requestModal,
      request_information: '',
    };
  }

  handleChange(event, key: StateKeys) {
    event.preventDefault();
    this.setState({ [key]: event.target.value } as Pick<State, keyof State>);
  }

  handleInfoRequest(event) {
    event.preventDefault();

    if (this.state.request_information !== '') {
      postJSON(this.props.urls.request_more_info_path, {
        info_params: this.state,
      })
        .then(e => {
          if (e.notice) {
            window.Alerts.notice(e.notice);

            this.setState({ request_information: '' });
            this.props.requestMadeTrigger();
            window.location.href = e.app_url || this.props.urls.inbox_path;
          } else {
            window.Alerts.alert(e.alert);
          }
        })
        .catch(handleRequestError);
    } else {
      window.alert('You must fill in the message input');
    }
  }

  handleCancel() {
    this.modalRef.current.close();
  }

  renderTextArea = () => (
    <TextInput
      name='request_information'
      color='puertoRico'
      id='request_information'
      label={`Ask ${this.props.name} for more information`}
      textarea={true}
      required={true}
      onChange={event => this.handleChange(event, 'request_information')}
      inputRef={this.messageRef}
    />
  );

  renderButtons = () => (
    <div className={styles.buttons}>
      <Button
        buttonColor='puertoRico'
        onClick={this.handleInfoRequest}
        otherClasses={styles.button}
      >
        Request info from candidate
      </Button>
      <Button
        buttonColor='silverSand'
        buttonType='border'
        onClick={this.handleCancel}
        otherClasses={styles.button}
      >
        Cancel
      </Button>
    </div>
  );

  renderContent = () => (
    <div>
      <div className={styles.subtitle}>{this.state.requestModal.subtitle}</div>
      <div className={styles.details}>{this.state.requestModal.details}</div>
      <div dangerouslySetInnerHTML={{ __html: this.state.requestModal.content }} />
      <div className={styles.date}>{this.state.requestModal.date}</div>
    </div>
  );

  renderButton = () => (
    <div className={styles.buttons}>
      <Button buttonColor='puertoRico' onClick={this.handleCancel}>
        Ok
      </Button>
    </div>
  );

  render() {
    return (
      <Modal title={this.state.requestModal.title} defaultOpen={true} ref={this.modalRef}>
        {this.state.requestModal.isReadOnly && this.renderContent()}
        {!this.state.requestModal.isReadOnly && this.renderTextArea()}
        <div className={styles.footer}>
          {this.state.requestModal.isReadOnly && this.renderButton()}
          {!this.state.requestModal.isReadOnly && this.renderButtons()}
        </div>
      </Modal>
    );
  }
  static show(applicationId, name, urls, requestMadeTrigger, requestInfo) {
    const root = $('<div id="request-info-message-container"></div>');

    $('body').append(root);

    ReactDOM.render(
      <RequestInfoModal
        applicationId={applicationId}
        name={name}
        requestMadeTrigger={requestMadeTrigger}
        urls={urls}
        requestInfo={requestInfo}
      />,
      root[0]
    );
  }
}

export default RequestInfoModal;
